Apt.fn.make('contact', {
	/**
	 * Initialize module
	 */
	init() {
		this.message = Apt.fn.message()
			.init({
				placeholder: 'Marketplace sales and support only',
				required: true
			});
	},

	/**
	 * Unload module
	 */
	unload() {
		LS.util.destroy(this, 'message');
	}
});